import { useState } from 'react';
import { faMagicWandSparkles } from '@fortawesome/pro-solid-svg-icons/faMagicWandSparkles';

import { FixedToast } from 'us-react-components/dist/FixedToast/FixedToast';
import { useDependencies } from '../../../dependencies';

// Mirrors complete-care-toast.js — fixed bottom banner shown to Kinside-
// partnered families on daycare search results. Offers VIP concierge support
// via /familyguide.
export const CompleteCareToast = (): JSX.Element => {
  const { services: { tracker } } = useDependencies();
  const [isOpen, setIsOpen] = useState(true);

  const handleClick = (): void => {
    tracker.track('clicked-button', {
      elementText: 'complete-care-toast-navigate',
    });
    window.open('/familyguide', '_blank');
  };

  const handleClose = (): void => {
    setIsOpen(false);
    tracker.track('clicked-button', {
      elementText: 'complete-care-toast-close',
    });
  };

  return (
    <div className='fixed-bottom-toast'>
      <FixedToast
        iconName={faMagicWandSparkles}
        displayText='Skip the search! Get VIP concierge support.'
        isOpen={isOpen}
        handleClick={handleClick}
        handleClose={handleClose}
      />
    </div>
  );
};
